export default __webpack_public_path__ + "static/media/ep2.78d47229.jpeg";